var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Phone",
    clipPath: "url(#clip0_118_514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 16.4239V19.9599C21.0001 20.2131 20.9042 20.4569 20.7316 20.6421C20.559 20.8273 20.3226 20.9402 20.07 20.9579C19.633 20.9879 19.276 21.0039 19 21.0039C10.163 21.0039 3 13.8409 3 5.00391C3 4.72791 3.015 4.37091 3.046 3.93391C3.06372 3.68135 3.17658 3.44492 3.3618 3.27232C3.54703 3.09971 3.79082 3.00379 4.044 3.00391H7.58C7.70404 3.00378 7.8237 3.04977 7.91573 3.13293C8.00776 3.21609 8.0656 3.33049 8.078 3.45391C8.101 3.68391 8.122 3.86691 8.142 4.00591C8.34073 5.39283 8.748 6.74174 9.35 8.00691C9.445 8.20691 9.383 8.44591 9.203 8.57391L7.045 10.1159C8.36445 13.1904 10.8145 15.6405 13.889 16.9599L15.429 14.8059C15.4919 14.7179 15.5838 14.6548 15.6885 14.6276C15.7932 14.6003 15.9042 14.6107 16.002 14.6569C17.267 15.2578 18.6156 15.664 20.002 15.8619C20.141 15.8819 20.324 15.9039 20.552 15.9259C20.6752 15.9385 20.7894 15.9965 20.8724 16.0885C20.9553 16.1805 21.0012 16.3 21.001 16.4239H21Z",
    fill: "#FFA3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.87771a0fec9b47dfe7ed2d237b21ee61.svg";
export { ForwardRef as ReactComponent };